import { handleToast } from 'helpers/handleToast';
import { useEffect, useState } from 'react';
import { formatErrorResponse, validate } from 'utils/zodValidation';
import { postProfile } from '../../Users.services';
import { NewProfileSchema } from './AddProfileDialog.schema';

type useAddProfileDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
};

export const useAddProfileDialog = ({
	open,
	setOpen,
}: useAddProfileDialogProps) => {
	const [name, setName] = useState<string>('');
	const [permissions, setPermissions] = useState<string[]>([]);
	const [fieldsWithErrors, setFieldsWithErrors] = useState<
		Record<string, string>
	>({});
	const [isLoading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		if (!open) return;

		setName('');
		setPermissions([]);
		setFieldsWithErrors({});
	}, [open]);

	const handleTogglePermission = (id: string, isChecked: boolean) => {
		setPermissions((previous) =>
			isChecked
				? [...previous, id]
				: previous.filter((permissionId) => permissionId !== id),
		);
	};

	const handleConfirm = async () => {
		setFieldsWithErrors({});
		setLoading(true);

		try {
			const validatedProfile = await validate(NewProfileSchema, {
				name,
				permissions,
			});

			await postProfile(validatedProfile);

			handleToast('success', '¡Perfil creado!');
			setOpen(false);
		} catch (error: any) {
			if (error.zodError) {
				setFieldsWithErrors(formatErrorResponse(error.zodError));
				return;
			}
			handleToast('error', '¡Error al crear el perfil!');
		} finally {
			setLoading(false);
		}
	};

	return {
		name,
		permissions,
		fieldsWithErrors,
		isLoading,
		setName,
		handleTogglePermission,
		handleConfirm,
	};
};
